import _ from 'lodash';

class B2BHelpers {
  static adjustKeys(keys, key, isAccessModeChanged, apiSecret) {
    const index = _.findIndex(keys, { api_key: key });
    const keysArray = Object.assign([], keys);

    if (index > -1) {
      const changedKey = Object.assign({}, keysArray[index]);

      if (isAccessModeChanged) {
        changedKey.access_mode = 0;
        changedKey.is_viewed = false;
        delete changedKey.api_secret;
      } else {
        changedKey.is_viewed = true;
        changedKey.api_secret = apiSecret;
      }

      keysArray[index] = changedKey;
    }

    return Object.assign([], keysArray);
  }

  static filterKeys(keys, active) {
    let result = Object.assign([], keys);

    return active
      ? _.filter(result, key => {
          return key.access_mode > 0;
        })
      : _.filter(result, key => {
          return key.access_mode === 0;
        });
  }
}

export default B2BHelpers;



// WEBPACK FOOTER //
// ./src/app/main/b2b/helpers/b2b-helpers.js